import cx from "classnames";
import React, { useState } from "react";
import { Button } from "reactstrap";

import { TextBlock } from "../../../types";
import { Props } from "../types";
import { browserSupportsEditing, extractTextBlock, extractHumanReadableText } from "../util";
import { Editing } from "./Editing";

type TextProps = Props<TextBlock> &
  Readonly<{
    previewImage?: React.ReactElement;
  }>;

export const Text = ({
  block,
  fontInformation,
  id,
  onAddCorrections,
  onSelectBlock,
  previewImage,
  referencesLink,
  selected,
}: TextProps) => {
  const [editing, setEditing] = useState(false);
  if (editing && !!onAddCorrections) {
    return (
      <Editing
        block={block}
        onCancel={() => {
          setEditing(false);
        }}
        onSave={(newCorrection: string) => {
          setEditing(false);
          onAddCorrections(block.id, newCorrection);
        }}
        previewImage={previewImage} 
      />
    );
  }
  return (
    <>
      <div
        className={cx("block", { editable: !!onAddCorrections, selected }, block.confidenceClass)}
        id={id}
        onClick={e => {
          e.preventDefault();
          if (!onSelectBlock) {
            return;
          }

          onSelectBlock(block.id, extractHumanReadableText(block.element), e.ctrlKey);
        }}
      >
        <div
          style={{
            display:"flex",
            alignItems:"center"
          }}
        >
          {!!onAddCorrections && (
            <Button
              className="btn-edit"
              color="link"
              onClick={e => {
                e.stopPropagation();
                if (!browserSupportsEditing()) {
                  window.alert("Editing contents are unsupported on this browser.");
                  return;
                }
                setEditing(true);
              }}
              title="Edit"
            >
              <i className="fa fa-edit" />
              <span className="sr-only">Edit</span>
            </Button>
          )}
          <span 
            style={{
              flex:1
            }}
          >
            {extractTextBlock(block.element, block.highlights)}
          </span>
        </div>
        {referencesLink}
      </div>
    </>
  );
};
Text.displayName = "Text";
